<template>
  <div id="course-chooser" class="page container">
    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <back-button :back-route="{name: 'areas'}"></back-button>
        <div class="row area-details">
          <div class="col-xs-8">
            <h4>{{ $t("AREA") }}</h4>
            <h1>{{ currentArea.name }}</h1>
            <p class="area-description">
              {{ currentArea.description }}
            </p>
            <div class="area-progress-container">
              <span class="area-progress-item svg-line">
                <check-badge-grey class="svg-icon"></check-badge-grey>
                <div>
                  {{ completeCategoriesCount }}<slash style="width: 6px; height: 10px; margin: 0 2px;"/><span class="all-count">{{ currentCategories.length }}</span>
                </div>
              </span>

              <div class="vertical-divider" style="height: 14px"></div>
              <span class="area-progress-item svg-line">
                <level class="svg-icon"></level>
                <div>
                  {{ currentProgress.level.name }}
                </div>
              </span>
            </div>
          </div>
          <div class="col-xs-4">
            <img class="img img-responsive" :src="currentArea.image" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-7">
            <!-- tests are bound to an area, so they belong on the area dashboard. Without a Focus
                 page (akademia2) there is nowhere else to surface them anyway. -->
            <assigned-tests v-if="showAssignedTests"></assigned-tests>

            <h3 class="section-title">{{ $t("CATEGORY_CHOOSER_COURSES") }}</h3>
            <div
              class="card"
              v-for="category in currentCategories"
              :key="category.id"
              style="margin-bottom: 20px"
            >
              <div class="row specific-course">
                <div class="col-xs-7 specific-course-description">
                  <div class="course-heading">
                    <div class="course-tags"></div>
                    <h1>{{ category.name }}</h1>
                  </div>
                  <div class="progress-and-button">
                    <progress-bar
                      :percent="categoryProgressPercent(category.id)"
                    ></progress-bar>

                    <button
                      @click="goToCategory(category.id)"
                      class="btn primary-btn"
                    >
                      {{ categoryProgressPercent(category.id) === 0 ? $t("BEGIN") : categoryProgressPercent(category.id) === 100 ? $t("VIEW_AGAIN") : $t("CONTINUE") }}
                    </button>
                  </div>
                </div>
                <div class="col-xs-5">
                  <div class="specific-course-image">
                    <img
                      class="img img-responsive"
                      :src="category.image_path"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-5">
            <div class="row">
              <div class="col-xs-12">
                <h3 class="section-title">
                  {{ $t("CATEGORY_CHOOSER_ACHIEVEMENTS") }}
                </h3>
                <div class="category-achievements">
                  <div
                    class="category-achievement unlocked"
                    v-for="achievement in currentUnlockedAchievements"
                    :key="achievement.id"
                    :title="achievement.name"
                  >
                    <img :src="achievement.image_path" />
                  </div>
                  <div
                    class="category-achievement locked"
                    v-for="achievement in currentLockedAchievements"
                    :key="achievement.id"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!---------------------------------------------------------------------------->
<script>
import { mapGetters } from "vuex";
import BackButton from "Components/common/BackButton";
import ProgressBar from "Components/common/ProgressBar";
import CheckBadgeGrey from "Components/Svg/CheckBadgeGrey";
import Level from "Components/Svg/Level";
import Slash from "Components/Svg/Slash";
import AssignedTests from "./AssignedTests";
import { sumBy } from "lodash/math";

const logTag = "CategoryChooser";

export default {
  components: { Level, CheckBadgeGrey, Slash, ProgressBar, BackButton, AssignedTests },

  data() {
    return {
      // akademia keeps its tests on the Focus page, so only list them here when there is no Focus page
      showAssignedTests: config.features.knowledgeTests && !config.features.itemPage,
    };
  },

  created: function () {
    this.$store.dispatch("changePreferredArea", parseInt(this.$route.params.area));
    // @note errors are handled in httpInterceptors
    this.$store.dispatch("downloadAchievements").catch(() => {});
  },

  watch: {
    "$route.params.area": function (newAreaId) {
      this.$store.dispatch("changePreferredArea", parseInt(newAreaId));
    },
  },

  computed: {
    ...mapGetters([
      "area",
      "currentCategories",
      "currentProgress",
      "categoriesProgress",
      "currentUnlockedAchievements",
      "currentLockedAchievements",
    ]),

    currentArea() {
      const areaId = this.$route.params.area;
      return this.area(areaId);
    },

    completeCategoriesCount() {
      const areaCategories = this.currentCategories;
      const categoriesProgress = this.categoriesProgress;
      return sumBy(areaCategories, function (category) {
        const progress = categoriesProgress[category.id];
        return progress.total_chapters === progress.complete_chapters ? 1 : 0;
      });
    },
  },

  methods: {
    goToCategory(categoryId) {
      this.$router.push(`/categories/${categoryId}`);
    },

    categoryProgressPercent(categoryId) {
      const progress = this.categoriesProgress[categoryId];
      return progress.total_content_units === 0
        ? 0
        : (progress.complete_content_units / progress.total_content_units) * 100;
    },
  },
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss"></style>
